'use strict';

(function () {
  'use strict';

  angular.module('msSleep').controller('SleepEntryDoneCtrl', SleepEntryDoneCtrl);

  /* @ngInject */
  SleepEntryDoneCtrl.$inject = ['$log', '$state', '$stateParams', 'NotifyingSvc'];

  function SleepEntryDoneCtrl($log, $state, $stateParams, NotifyingSvc) {
    var vm = this;
    vm.$onInit = function () {
      $log.debug('SleepEntryCompleteCtrl activate');
      vm.day = $stateParams.day;
      vm.entry = _.get($stateParams, 'entryData.entries["' + vm.day + '"]');
      //notify that entry has been created so Print button can show if not already
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.ENTRY_CREATED);
    };
    vm.continue = function () {
      var reqmt = _.get($stateParams, 'requirements[0].requirementType');
      if (reqmt && reqmt === 'SLEEP_INITIAL_SCHEDULE') {
        $state.go('vnext.content.sleep.main.schedule');
      } else {
        $state.go('vnext.content.sleep.main.diary');
      }
    };
  }
})();